<template>
  <nav class="sn-navbar" id="navbarBlur">
    <div class="sn-navbar-inner">

      <!-- Left: Hamburger (mobile only) -->
      <a href="javascript:;" class="sn-hamburger d-xl-none" @click="toggleSidebar" title="Menu">
        <span></span><span></span><span></span>
      </a>
      <!-- Left spacer on desktop so the right-side pill sits flush right -->
      <div class="d-none d-xl-block"></div>

      <!-- Right: frosted pill -->
      <div class="sn-actions">

        <!-- SMS Balance chip (click to open buy modal) -->
        <button class="sn-sms-chip" @click="showBuyModal = true" title="SMS Balance — Click to purchase">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <span class="sn-sms-count">{{ smsBalanceDisplay }}</span>
        </button>

        <!-- Profile dropdown -->
        <div class="nav-item dropdown">
          <button class="sn-profile-btn" id="profileDropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="sn-avatar-wrap">
              <img v-if="imageSrc" :src="imageSrc" class="sn-avatar-img" @error="imageSrc = null" alt="" />
              <span v-else class="sn-avatar-img sn-avatar-fallback">{{ userInitials }}</span>
            </div>
            <span class="sn-uname">{{ Loggedinas }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end px-2 py-3 border-0 shadow-lg border-radius-xl mt-2" aria-labelledby="profileDropdown">
            <li class="mb-2">
              <a class="dropdown-item border-radius-md" href="javascript:;" @click="showPassModal = true">
                <div class="d-flex align-items-center py-1">
                  <div class="icon-shape icon-sm bg-gradient-info shadow text-center border-radius-md me-2 d-flex align-items-center justify-content-center">
                    <span class="material-icons text-white text-sm">password</span>
                  </div>
                  <span class="text-sm font-weight-normal">Change password</span>
                </div>
              </a>
            </li>
            <li>
              <a class="dropdown-item border-radius-md" href="javascript:;" @click="logout">
                <div class="d-flex align-items-center py-1">
                  <div class="icon-shape icon-sm bg-gradient-danger shadow text-center border-radius-md me-2 d-flex align-items-center justify-content-center">
                    <span class="material-icons text-white text-sm">logout</span>
                  </div>
                  <span class="text-sm font-weight-normal">Sign out</span>
                </div>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </nav>

  <!-- ═══ BUY SMS MODAL ═══ -->
  <div v-if="showBuyModal" class="sn-overlay" @mousedown.self="showBuyModal = false">
    <div class="sn-modal" style="max-width:480px;">
      <div class="sn-modal-head">
        <div>
          <h5 class="sn-modal-title">Purchase SMS Units</h5>
          <p style="font-size:11px;color:#94a3b8;margin:2px 0 0">Pay via M-Pesa STK Push</p>
        </div>
        <button class="sn-modal-close" @click="showBuyModal = false">&times;</button>
      </div>
      <div class="sn-modal-body">
        <div class="sn-fg">
          <label class="sn-fl">M-Pesa Phone Number</label>
          <input v-model="buyPhone" type="tel" class="sn-fi" placeholder="07XX XXX XXX" />
        </div>

        <div v-if="ratesLoading" style="text-align:center;padding:24px;color:#94a3b8;">Loading plans...</div>
        <div v-else-if="smsRates.length === 0" style="text-align:center;padding:24px;color:#94a3b8;font-size:13px;">No SMS plans available</div>
        <div v-else class="sn-plans-grid">
          <div v-for="r in smsRates" :key="r.Id || r.id" class="sn-plan"
               :class="{'sn-plan-on': selectedPlan?.Id === r.Id || selectedPlan?.id === r.id}"
               @click="selectedPlan = r">
            <div class="sn-plan-units">{{ Number(r.units || r.Units || 0).toLocaleString() }}</div>
            <div class="sn-plan-label">SMS units</div>
            <div class="sn-plan-price">KES {{ Number(r.price || r.Price || 0).toLocaleString() }}</div>
          </div>
        </div>

        <div v-if="buyStatus" class="sn-status" :class="buyStatus.type">{{ buyStatus.text }}</div>
      </div>
      <div class="sn-modal-foot">
        <a href="javascript:;" style="font-size:12px;color:#e91e63;font-weight:600;"
           @click="showBuyModal = false; showHistoryModal = true; loadHistory();">Purchase history</a>
        <div style="flex:1"></div>
        <button class="sn-btn-ghost" @click="showBuyModal = false">Cancel</button>
        <button class="sn-btn-primary" :disabled="!selectedPlan || !buyPhone || isBuying" @click="purchaseSms">
          {{ isBuying ? 'Processing...' : 'Pay KES ' + (selectedPlan ? Number(selectedPlan.price || selectedPlan.Price || 0).toLocaleString() : '0') }}
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ SMS HISTORY MODAL ═══ -->
  <div v-if="showHistoryModal" class="sn-overlay" @mousedown.self="showHistoryModal = false">
    <div class="sn-modal" style="max-width:560px;">
      <div class="sn-modal-head">
        <h5 class="sn-modal-title">SMS Purchase History</h5>
        <button class="sn-modal-close" @click="showHistoryModal = false">&times;</button>
      </div>
      <div class="sn-modal-body">
        <div v-if="historyLoading" style="text-align:center;padding:24px;color:#94a3b8;">Loading...</div>
        <div v-else-if="smsHistory.length === 0" style="text-align:center;padding:24px;color:#94a3b8;">No purchase history</div>
        <div v-else>
          <div v-for="(h, i) in smsHistory" :key="i" class="sn-hist-row">
            <div>
              <div class="sn-hist-units">{{ h.units || h.Units }} units</div>
              <div class="sn-hist-meta">{{ h.date || h.Date || h.created_at || '—' }}</div>
            </div>
            <div style="text-align:right;">
              <div class="sn-hist-amount">KES {{ Number(h.amount || h.Amount || h.price || 0).toLocaleString() }}</div>
              <span class="sn-hist-status" :class="'sn-st-' + String(h.status || h.Status || 'pending').toLowerCase()">{{ h.status || h.Status || 'Pending' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ PASSWORD MODAL ═══ -->
  <div v-if="showPassModal" class="sn-overlay" @mousedown.self="showPassModal = false">
    <div class="sn-modal" style="max-width:380px;">
      <div class="sn-modal-head">
        <h5 class="sn-modal-title">Change Password</h5>
        <button class="sn-modal-close" @click="showPassModal = false">&times;</button>
      </div>
      <div class="sn-modal-body">
        <div class="sn-fg"><label class="sn-fl">Current password</label><input v-model.trim="form.oldPass" type="password" class="sn-fi" :disabled="loading" autocomplete="current-password" /></div>
        <div class="sn-fg"><label class="sn-fl">New password</label><input v-model="form.newPass" type="password" class="sn-fi" :disabled="loading" autocomplete="new-password" /></div>
        <div class="sn-fg"><label class="sn-fl">Confirm password</label><input v-model="form.confirmNewPass" type="password" class="sn-fi" :disabled="loading" autocomplete="new-password" /></div>
        <p v-if="hint" style="font-size:11px;color:#d97706;margin-top:-4px;">{{ hint }}</p>
      </div>
      <div class="sn-modal-foot">
        <div style="flex:1"></div>
        <button class="sn-btn-ghost" @click="showPassModal = false" :disabled="loading">Cancel</button>
        <button class="sn-btn-primary" @click="handleUpdatePassword" :disabled="loading || !!hint">
          {{ loading ? 'Updating...' : 'Update' }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import { mapMutations, mapState } from "vuex";
import { activateDarkMode } from "@/utils/themeMode";
import apiService from '@/apis/apiService';
import Swal from 'sweetalert2';

export default {
  name: "AcademicsNavBar",

  data() {
    return {
      imageSrc: null,
      Loggedinas: '',
      smsBalance: null,

      // Buy SMS
      showBuyModal: false,
      smsRates: [],
      ratesLoading: false,
      selectedPlan: null,
      buyPhone: '',
      isBuying: false,
      buyStatus: null,

      // History
      showHistoryModal: false,
      smsHistory: [],
      historyLoading: false,

      // Password
      showPassModal: false,
      loading: false,
      form: { oldPass: '', newPass: '', confirmNewPass: '' },
    };
  },

  computed: {
    ...mapState(["isRTL", "isAbsolute"]),
    currentRouteName() { return this.$route.name; },

    userInitials() {
      const parts = (this.Loggedinas || '').trim().split(/\s+/);
      return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
    },

    /**
     * SMS balance display with two guard cases:
     *   - balance hasn't been loaded yet (null) → dash
     *   - balance is NaN (from a bad response parse) → dash
     * Because `NaN != null` is true, we need an explicit isFinite check.
     */
    smsBalanceDisplay() {
      const v = this.smsBalance;
      return (v != null && Number.isFinite(v)) ? Math.floor(v).toLocaleString() : '–';
    },

    hint() {
      const { newPass, confirmNewPass } = this.form;
      if (!newPass && !confirmNewPass) return '';
      if (newPass && newPass.length < 5) return 'Password must be at least 5 characters.';
      if (confirmNewPass && newPass !== confirmNewPass) return 'Passwords do not match.';
      return '';
    },
  },

  mounted() {
    this.imageSrc = localStorage.getItem('loggedinimage');
    this.Loggedinas = localStorage.getItem('loggedinas') || '';
    this.darkMode(localStorage.getItem('theme'));
    this.fetchSmsBalance();
  },

  beforeUnmount() {
    if (this._smsBuyTimeout) { clearTimeout(this._smsBuyTimeout); this._smsBuyTimeout = null; }
    if (this._smsBuyClient) try { this._smsBuyClient.deactivate(); } catch (e) { /* cleanup */ }
  },

  methods: {
    ...mapMutations(["navbarMinimize"]),

    toggleSidebar() { this.navbarMinimize(); },

    darkMode(value) {
      if (value == 0) {
        this.$store.state.isDarkMode = false;
      } else {
        this.$store.state.isDarkMode = true;
        activateDarkMode();
      }
    },

    logout() { apiService.logout(); },

    // ── SMS Balance ──────────────────────────────────────────────────
    async fetchSmsBalance() {
      try {
        const res = await apiService.apiClient.get('/api/sms/getaccoutbal');
        let raw = res.data;
        if (Array.isArray(raw) && raw.length > 0) raw = raw[0];
        if (typeof raw === 'string') { try { raw = JSON.parse(raw); } catch (e) { /* plain string */ } }
        let bal = 0;
        if (typeof raw === 'object' && raw !== null) {
          let v = raw.smsaccbal || raw.balance || raw.smsBalance || raw.smsbalance || '0';
          bal = parseFloat(String(v).replace(/,/g, ''));
        } else {
          bal = parseFloat(String(raw).replace(/,/g, ''));
        }
        if (!isNaN(bal)) this.smsBalance = bal;
      } catch (e) { console.error('SMS Balance error:', e); }
    },

    // ── Buy SMS ──────────────────────────────────────────────────────
    async loadRates() {
      if (this.smsRates.length) return;
      this.ratesLoading = true;
      try {
        const res = await apiService.apiClient.get('/api/sms/rates');
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.smsRates = (data || []).filter(r => !r.querystatus);
      } catch (e) { console.warn('Failed to load SMS rates:', e); }
      finally { this.ratesLoading = false; }
    },

    async purchaseSms() {
      if (!this.selectedPlan || !this.buyPhone || this.isBuying) return;
      this.isBuying = true;
      this.buyStatus = null;
      try {
        const res = await apiService.apiClient.post('/api/sms/buy', {
          planId: this.selectedPlan.Id || this.selectedPlan.id,
          phone: this.buyPhone,
          amount: this.selectedPlan.price || this.selectedPlan.Price,
        });
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        const msg = data?.message || data?.querystatus || 'STK push sent. Enter your M-Pesa PIN to confirm.';
        const isErr = /fail|error|denied/i.test(msg);
        this.buyStatus = { text: msg, type: isErr ? 'error' : 'info' };
        const checkoutRequestID = data?.checkoutRequestID;
        if (!isErr && checkoutRequestID) {
          this.subscribeSmsBuyStatus(checkoutRequestID);
        } else {
          this.isBuying = false;
        }
      } catch (e) {
        this.buyStatus = { text: e?.response?.data?.message || 'Purchase failed.', type: 'error' };
        this.isBuying = false;
      }
    },
    subscribeSmsBuyStatus(checkoutRequestID) {
      this.cleanupSmsBuySubscription();
      try {
        const SockJS = require('sockjs-client');
        const { Client } = require('@stomp/stompjs');
        const token = localStorage.getItem('authToken') || '';
        const buyClient = new Client({
          webSocketFactory: () => new SockJS(`${window.location.origin}/ws?token=${token}`),
          reconnectDelay: 0,
          onConnect: () => {
            buyClient.subscribe('/topic/subscribe-status-' + checkoutRequestID, (msg) => {
              this.handleSmsBuyStatusMessage(String(msg.body || ''));
            });
          },
        });
        this._smsBuyClient = buyClient;
        buyClient.activate();
        this._smsBuyTimeout = setTimeout(() => {
          if (this.isBuying) {
            this.isBuying = false;
            this.buyStatus = { type: 'info', text: 'Still waiting on M-Pesa. Check Purchase History to verify status.' };
          }
          this.cleanupSmsBuySubscription();
        }, 120000);
      } catch (e) {
        this.isBuying = false;
      }
    },
    handleSmsBuyStatusMessage(text) {
      const lower = text.toLowerCase();
      const isSuccess = lower.includes('successfully purchased');
      const isCancel = lower.includes('cancelled');
      const isError = lower.includes('error has occurred') || lower.includes('failed');
      if (isSuccess) {
        this.buyStatus = { type: 'success', text };
        this.fetchSmsBalance();
        this.isBuying = false;
        setTimeout(() => { this.showBuyModal = false; }, 1500);
      } else if (isCancel || isError) {
        this.buyStatus = { type: 'error', text };
        this.isBuying = false;
      } else {
        this.buyStatus = { type: 'info', text };
      }
      if (isSuccess || isCancel || isError) {
        this.cleanupSmsBuySubscription();
      }
    },
    cleanupSmsBuySubscription() {
      if (this._smsBuyTimeout) { clearTimeout(this._smsBuyTimeout); this._smsBuyTimeout = null; }
      if (this._smsBuyClient) {
        try { this._smsBuyClient.deactivate(); } catch (e) { /* ignore */ }
        this._smsBuyClient = null;
      }
    },

    // ── History ──────────────────────────────────────────────────────
    async loadHistory() {
      this.historyLoading = true;
      try {
        const res = await apiService.apiClient.get('/api/sms/buy/history');
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.smsHistory = (data || []).filter(h => !h.querystatus);
      } catch (e) { console.warn('History error:', e); }
      finally { this.historyLoading = false; }
    },

    // ── Password ─────────────────────────────────────────────────────
    async handleUpdatePassword() {
      if (this.loading || this.hint) return;
      this.loading = true;
      try {
        const res = await apiService.apiClient.post('/api/settings/postupdatepass', {
          oldpass: this.form.oldPass,
          newpass: this.form.newPass,
        });
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        const msg = data?.querystatus || data?.message || data?.[0]?.querystatus || 'Password updated.';
        const isErr = /fail|error|invalid|wrong/i.test(msg);
        Swal.fire(isErr ? 'Error' : 'Success', msg, isErr ? 'error' : 'success');
        if (!isErr) {
          this.showPassModal = false;
          this.form = { oldPass: '', newPass: '', confirmNewPass: '' };
        }
      } catch (e) {
        Swal.fire('Error', e?.response?.data?.message || 'Failed to update password.', 'error');
      } finally { this.loading = false; }
    },
  },

  watch: {
    showBuyModal(v) { if (v) this.loadRates(); },
  },
};
</script>

<style scoped>
.sn-navbar { position: sticky; top: 0; z-index: var(--z-navbar) !important; margin: 0 16px; padding: 12px 8px; background: transparent; }
.sn-navbar-inner { display: flex; align-items: center; justify-content: space-between; gap: 12px; }

.sn-hamburger { display: flex; flex-direction: column; gap: 4px; padding: 8px; border: none; background: transparent; cursor: pointer; border-radius: 8px; transition: background 0.15s; text-decoration: none; }
.sn-hamburger:hover { background: rgba(0,0,0,0.04); }
.sn-hamburger span { display: block; width: 18px; height: 2px; background: rgba(0,0,0,0.5); border-radius: 2px; }

.sn-actions { display: flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.82); backdrop-filter: blur(14px); border: 1px solid rgba(0,0,0,0.06); border-radius: 28px; padding: 2px 14px; box-shadow: 0 2px 12px rgba(0,0,0,0.04); }

/* SMS chip */
.sn-sms-chip { display: flex; align-items: center; gap: 5px; padding: 4px 10px 4px 8px; border-radius: 20px; border: 1px solid rgba(233,30,99,0.15); background: rgba(233,30,99,0.06); color: #e91e63; cursor: pointer; transition: all 0.15s; font-family: inherit; white-space: nowrap; }
.sn-sms-chip:hover { background: rgba(233,30,99,0.12); border-color: rgba(233,30,99,0.3); }
.sn-sms-count { font-size: 11px; font-weight: 700; }

/* Profile */
.sn-profile-btn { display: flex; align-items: center; gap: 8px; padding: 3px 8px 3px 3px; border-radius: 24px; border: none; background: transparent; cursor: pointer; transition: all 0.15s; font-family: inherit; }
.sn-profile-btn:hover { background: rgba(0,0,0,0.04); }
.sn-avatar-img { width: 28px; height: 28px; border-radius: 50%; object-fit: cover; display: block; }
.sn-avatar-fallback { display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #e91e63, #9c27b0); color: #fff; font-size: 10px; font-weight: 800; }
.sn-uname { font-size: 12px; font-weight: 600; color: rgba(0,0,0,0.6); max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
@media (max-width: 576px) { .sn-uname { display: none; } }
</style>

<!-- Non-scoped: dark mode + modals (rendered outside scoped tree) -->
<style>
body.dark-version .sn-actions { background: rgba(26,28,46,0.85); border-color: rgba(255,255,255,0.06); box-shadow: 0 2px 12px rgba(0,0,0,0.2); }
body.dark-version .sn-hamburger span { background: rgba(255,255,255,0.5); }
body.dark-version .sn-hamburger:hover { background: rgba(255,255,255,0.06); }
body.dark-version .sn-sms-chip { background: rgba(233,30,99,0.1); border-color: rgba(233,30,99,0.2); color: #f48fb1; }
body.dark-version .sn-sms-chip:hover { background: rgba(233,30,99,0.18); border-color: rgba(233,30,99,0.35); }
body.dark-version .sn-profile-btn:hover { background: rgba(255,255,255,0.06); }
body.dark-version .sn-uname { color: rgba(255,255,255,0.6); }
body.dark-version .sn-avatar-fallback { background: linear-gradient(135deg, #c2185b, #7b1fa2); }

.sn-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); backdrop-filter: blur(6px); z-index: var(--z-page-dropdown) !important; display: flex; align-items: center; justify-content: center; padding: 20px; }
.sn-modal { background: #fff; border: 1px solid rgba(0,0,0,0.06); border-radius: 20px; width: 100%; box-shadow: 0 24px 60px rgba(0,0,0,0.18); overflow: hidden; max-height: 85vh; display: flex; flex-direction: column; }
.sn-modal-head { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px; border-bottom: 1px solid rgba(0,0,0,0.06); }
.sn-modal-title { font-size: 17px; font-weight: 800; color: #1a1c2e; margin: 0; }
.sn-modal-close { background: none; border: none; font-size: 22px; color: #94a3b8; cursor: pointer; padding: 0 4px; line-height: 1; }
.sn-modal-close:hover { color: #1a1c2e; }
.sn-modal-body { padding: 20px 24px; overflow-y: auto; flex: 1; }
.sn-modal-foot { padding: 16px 24px; border-top: 1px solid rgba(0,0,0,0.06); display: flex; align-items: center; gap: 8px; }

.sn-fg { margin-bottom: 14px; }
.sn-fl { display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: rgba(0,0,0,0.4); margin-bottom: 5px; }
.sn-fi { width: 100%; padding: 10px 14px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.1); background: rgba(0,0,0,0.02); color: #1a1c2e; font-size: 13px; box-sizing: border-box; outline: none; font-family: inherit; }
.sn-fi:focus { border-color: #e91e63; }
.sn-btn-ghost { padding: 8px 18px; border-radius: 10px; font-size: 13px; font-weight: 600; border: none; background: #f1f5f9; color: #64748b; cursor: pointer; font-family: inherit; }
.sn-btn-ghost:hover { background: #e2e8f0; }
.sn-btn-primary { padding: 8px 18px; border-radius: 10px; font-size: 13px; font-weight: 700; border: none; background: #e91e63; color: #fff; cursor: pointer; font-family: inherit; }
.sn-btn-primary:hover { background: #c2185b; }
.sn-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

.sn-plans-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 8px; }
.sn-plan { padding: 14px 10px; border: 1.5px solid rgba(0,0,0,0.08); border-radius: 12px; text-align: center; cursor: pointer; transition: all 0.15s; }
.sn-plan:hover { border-color: #f48fb1; background: rgba(233,30,99,0.04); }
.sn-plan-on { border-color: #e91e63 !important; background: rgba(233,30,99,0.06); box-shadow: 0 0 0 3px rgba(233,30,99,0.1); }
.sn-plan-units { font-size: 22px; font-weight: 800; color: #1a1c2e; line-height: 1; }
.sn-plan-label { font-size: 10px; color: #94a3b8; text-transform: uppercase; margin: 2px 0 8px; }
.sn-plan-price { font-size: 14px; font-weight: 700; color: #e91e63; }
.sn-status { margin-top: 12px; padding: 10px 14px; border-radius: 8px; font-size: 12px; font-weight: 600; }
.sn-status.success { background: #dcfce7; color: #166534; }
.sn-status.error { background: #fee2e2; color: #991b1b; }

.sn-hist-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid rgba(0,0,0,0.04); }
.sn-hist-row:last-child { border-bottom: none; }
.sn-hist-units { font-size: 14px; font-weight: 700; color: #1a1c2e; }
.sn-hist-meta { font-size: 11px; color: #94a3b8; margin-top: 1px; }
.sn-hist-amount { font-size: 13px; font-weight: 600; color: #1a1c2e; }
.sn-hist-status { display: inline-block; font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 10px; margin-top: 2px; text-transform: uppercase; }
.sn-st-successful { background: #dcfce7; color: #166534; }
.sn-st-pending { background: #fef3c7; color: #92400e; }
.sn-st-cancelled { background: #f1f5f9; color: #64748b; }
.sn-st-failed { background: #fee2e2; color: #991b1b; }

/* Dark mode for modals */
body.dark-version .sn-modal { background: #1a1c2e; border-color: rgba(255,255,255,0.08); }
body.dark-version .sn-modal-title { color: #eef0f6; }
body.dark-version .sn-modal-close:hover { color: #eef0f6; }
body.dark-version .sn-modal-head { border-color: rgba(255,255,255,0.06); }
body.dark-version .sn-modal-foot { border-color: rgba(255,255,255,0.06); }
body.dark-version .sn-fl { color: rgba(255,255,255,0.4); }
body.dark-version .sn-fi { background: rgba(255,255,255,0.05); border-color: rgba(255,255,255,0.1); color: #eef0f6; }
body.dark-version .sn-fi:focus { border-color: #e91e63; }
body.dark-version .sn-btn-ghost { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.6); }
body.dark-version .sn-plan { border-color: rgba(255,255,255,0.08); }
body.dark-version .sn-plan:hover { border-color: rgba(233,30,99,0.3); background: rgba(233,30,99,0.06); }
body.dark-version .sn-plan-on { border-color: #e91e63; background: rgba(233,30,99,0.1); }
body.dark-version .sn-plan-units { color: #eef0f6; }
body.dark-version .sn-hist-units { color: #eef0f6; }
body.dark-version .sn-hist-amount { color: #eef0f6; }
body.dark-version .sn-hist-row { border-color: rgba(255,255,255,0.04); }
body.dark-version .dropdown-menu { background: #1a1c2e; border-color: rgba(255,255,255,0.08); }
body.dark-version .dropdown-item { color: rgba(255,255,255,0.7); }
body.dark-version .dropdown-item:hover { background: rgba(255,255,255,0.06); color: #fff; }
body.dark-version .sn-modal-close { filter: invert(0.7); }

@media (max-width: 767px) {
  .sn-navbar { margin: 0 10px; padding: 10px 6px; }
  .sn-actions { padding: 2px 10px; gap: 4px; }
}
</style>
